import EmailInteractionEvent from "../../../email/controller/EmailInteractionEvent";
import SmartphoneNavigateEvent from "../../model/SmartphoneNavigateEvent";
import SmartphoneSkinKeyRegistry from "../../model/SmartphoneSkinKeyRegistry";
import AbstractSmartphoneMediator from "../AbstractSmartphoneMediator";

export default class SmartphoneEmailInboxScreenMediator extends AbstractSmartphoneMediator {
    constructor(target, dispatcher, emailModel, languagePack, mediatorManager, soundManager) {
        super(target, dispatcher);

        this._emailModel = emailModel;
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._emailBoxSelectionMediator = this._mediatorManager.createMediator(this._target.boxButtons, SmartphoneSkinKeyRegistry.EMAIL_BOX_SELECTION_SKIN);

        this._target.applicationTitleTextField.text = this._languagePack.getText("email.boxSelection.selectionLabel");

        this._buttonClose = this.createInterfaceButton(this._target.closeButton, this._handleCloseButtonClick.bind(this));

        this.registerEventListener(EmailInteractionEvent.OPEN_MAILBOX, this._handleOpenMailboxRequest.bind(this));
    }

    destroy() {
        super.destroy();

        this._emailBoxSelectionMediator.destroy();
    }

    _handleOpenMailboxRequest(event) {
        this.openScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_EMAIL_BOX_SCREEN_SKIN, null, { boxType: event.params.boxType });
    }

    _handleCloseButtonClick(mouseEvent) {
        const navEvt = new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_ALL_SCREENS_REQUEST);
        this.dispatch(navEvt.type, { data: navEvt });

        this.gotoScreen(SmartphoneSkinKeyRegistry.SMARTPHONE_MAIN_SCREEN_SKIN);
    }
}